import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";

/**
 * A modal component that displays the results of a data processing operation.
 * @param {Object} props - The props object containing the following properties:
 *   - {string} title - The title of the modal.
 *   - {number} total - The total number of rows processed.
 *   - {number} failedTotal - The total number of rows that failed.
 *   - {Array} emptyRows - An array of row numbers that are empty.
 *   - {Array} invalidRows - An array of row numbers that are invalid.
 *   - {boolean} show - Determines whether the modal is shown or hidden.
 *   - {function} handleClose - The function to close the modal.
 * @returns The rendered
 */
const SuccessModal = (props) => {
  const { t } = useTranslation();

  const {
    title,
    total,
    failedTotal,
    emptyRows,
    validRows,
    invalidRows,
    show,
    handleClose,
  } = props;
  return (
    /**
     * Renders a modal component with the given properties and content.
     * @param {boolean} show - Determines whether the modal is shown or hidden.
     * @param {function} onHide - Callback function to handle the modal close event.
     * @param {string} title - The title of the modal.
     * @param {number} total - The total number of rows.
     * @param {number} failedTotal - The total number of failed rows.
     * @param {Array<number>} invalidRows - An array of invalid row numbers.
     * @param {Array<number>} emptyRows - An array of empty row numbers.
     * @returns A modal component with the specified properties and content.
     */
    <div
      className="modal show"
    >
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            <b>{t("TOTAL_ROWS")}: </b>
            {total}
          </p>
          <p>
            <b>{t("SUCCESS_ROWS")}: </b>
            {total - failedTotal}
          </p>
          <p>
            <b>{t("FAILED_ROWS")}: </b>
            {failedTotal}
          </p>
          <p>
            <b>{t("VALID_ROW_NUMBERS")}: </b>
            {validRows?.join(", ")}
          </p>
          <p>
            <b>{t("INVALID_ROW_NUMBERS")}: </b>
            {invalidRows?.join(", ")}
          </p>
          <p>
            <b>{t("EMPTY_ROW_NUMBERS")}: </b>
            {emptyRows?.join(", ")}
          </p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SuccessModal;
